"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectResponseModelSourceType = void 0;
exports.ProjectResponseModelSourceType = {
    Blank: "blank",
    Book: "book",
    Article: "article",
    Genfm: "genfm",
    Video: "video",
};
